import { Injectable } from '@angular/core';

export interface PaisModel {
  pais: string;
  nombre: string;
  flag: string;
}

@Injectable({
  providedIn: 'root'
})
export class Geography {

  public paises: PaisModel[];

  initializePaises() {

    this.paises = [
      {
        pais: 'cl',
        nombre: 'Chile',
        flag: '/assets/flags/cl.svg'
      },
      {
        pais: 'co',
        nombre: 'Colombia',
        flag: '/assets/flags/co.svg'
      },
      {
        pais: 'cr',
        nombre: 'Costa Rica',
        flag: '/assets/flags/cr.svg'
      },
      {
        pais: 'ec',
        nombre: 'Ecuador',
        flag: '/assets/flags/ec.svg'
      },
      {
        pais: 'es',
        nombre: 'España',
        flag: '/assets/flags/es.svg'
      },
      {
        pais: 'mx',
        nombre: 'México',
        flag: '/assets/flags/mx.svg'
      },
      {
        pais: 'pa',
        nombre: 'Panamá',
        flag: '/assets/flags/pa.svg'
      },
      {
        pais: 'pe',
        nombre: 'Perú',
        flag: '/assets/flags/pe.svg'
      },
      {
        pais: 'pr',
        nombre: 'Puerto Rico',
        flag: '/assets/flags/pr.svg'
      },

    ];
  }
}